import {JacksonType, JsonSubType} from "@sonner/jackson-service-v2";
import {Papel} from "./papel";
import {PerfilEnum} from "../enums/perfil.enum";

@JacksonType("Banco")
@JsonSubType({key: 'br.com.sonner.iss.entity.Banco', type: "Papel"})
export class Banco extends Papel {

  constructor() {
    super(PerfilEnum.banco);
  }
}
